import {styled} from '@mui/material';
import {StyledProps} from './types';

const StyledFooterWrapper = styled('footer')<StyledProps>`
	${({$noMargin}) => $noMargin && 'margin: 0 !important;'}

	margin: 16px 16px 72px;
	${({$customMarginBottom}) => $customMarginBottom && `margin-bottom: ${$customMarginBottom};`}

	${({theme}) => theme.breakpoints.up('sm')} {
		margin: 32px 32px 88px;

		${({$customMarginBottom}) =>
			$customMarginBottom && `margin-bottom: ${$customMarginBottom};`}
	}

	${({theme}) => theme.breakpoints.up('md')} {
		margin: 32px;
	}
`;

export {StyledFooterWrapper};
